// extracted by mini-css-extract-plugin
module.exports = {"text":"NotificacaoContentText_text__31dAd"};